import { TChatOnboardingType } from '../../types/chatOnboarding';

export const CHAT_ONBOARDING_COOKIE_NAME_MAP: Record<TChatOnboardingType, string> = {
  builder: 'newbuilding-card-desktop-frontend.builder_chat_onboarding_shown',
  consultant: 'newbuilding-card-desktop-frontend.consultant_chat_onboarding_shown',
};

export const CHAT_ONBOARDING_CONFIG_MAP: Record<TChatOnboardingType, string> = {
  builder: 'Newbuilding.CianChatOnboarding.Enabled',
  consultant: 'Newbuilding.CianConsultantsChatOnboarding.Enabled',
};

export const CHAT_ONBOARDING_TEXT: Record<TChatOnboardingType, string> = {
  builder: 'Newbuilding.CianChatOnboarding.Text',
  consultant: 'Newbuilding.CianConsultantsChatOnboarding.Text',
};
